import { createContext, ReactNode, useContext, useMemo, useState } from 'react'
import { useMediaQuery } from '@common/ui/mantine'

export const COMPACT_NAVIGATION_MEDIA_QUERY = '(max-width: 899.9px)'

type CompactNavigationState = {
  isCompact: boolean
  drawerOpen: boolean
  toggleDrawer: () => void
  closeDrawer: () => void
}

const CompactNavigationContext = createContext<CompactNavigationState>({
  isCompact: false,
  drawerOpen: false,
  toggleDrawer: () => {},
  closeDrawer: () => {},
})

export const CompactNavigationProvider = ({ children }: { children: ReactNode }) => {
  const isCompact = useMediaQuery(COMPACT_NAVIGATION_MEDIA_QUERY, false, { getInitialValueInEffect: false }) ?? false
  const [drawerOpen, setDrawerOpen] = useState(false)

  const value = useMemo(
    () => ({
      isCompact,
      drawerOpen: isCompact && drawerOpen,
      toggleDrawer: () => setDrawerOpen((prev) => !prev),
      closeDrawer: () => setDrawerOpen(false),
    }),
    [isCompact, drawerOpen]
  )

  return <CompactNavigationContext.Provider value={value}>{children}</CompactNavigationContext.Provider>
}

export const useCompactNavigation = () => useContext(CompactNavigationContext)
